"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleBadge = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../icons");
var styled_components_1 = require("styled-components");
var BadgeAdmin = icons_1.icons.BadgeAdmin, BadgeSuperAdmin = icons_1.icons.BadgeSuperAdmin, BadgeMod = icons_1.icons.BadgeMod, BadgeVetted = icons_1.icons.BadgeVetted;
/**
 * @Component Component for displaying a badge for a user role.
 *
 * - The props object containing the following properties:
 * @prop {string} props.role : The role to display (default: undefined).
 * @prop {string} props.value : The value of the role to display (default: undefined).
 * @prop {string} props.className : Class to add to the component (default: undefined).
 * @prop {DefaultTheme} props.dummyThemeFromStoryBook : Theme to use (only for StoryBook, do not use in app) (default: undefined).
 */
var UserRoleBadge = function (_a) {
    var _b, _c;
    var role = _a.role, value = _a.value, className = _a.className, dummyThemeFromStoryBook = _a.dummyThemeFromStoryBook;
    var badges = { BadgeAdmin: BadgeAdmin, BadgeSuperAdmin: BadgeSuperAdmin, BadgeMod: BadgeMod, BadgeVetted: BadgeVetted };
    var theme = (0, styled_components_1.useTheme)() || dummyThemeFromStoryBook;
    var iconName = (_c = (_b = theme === null || theme === void 0 ? void 0 : theme['_Roles']) === null || _b === void 0 ? void 0 : _b[value || role]) === null || _c === void 0 ? void 0 : _c['badgeIcon'];
    var Icon = iconName && badges[iconName];
    return (Icon ? (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Icon, null))) : null);
};
exports.UserRoleBadge = UserRoleBadge;
